import { useParams } from 'react-router-dom';
import TradeInWidget from './TradeInWidget';
import PageNotFound from '../../components/PageNotFound';
import LeadGenWidget from './LeadGenWidget';
import GoogleReviewWidget from './GoogleReview';
import XRMLeadGenWidget from './XRMLeadGen';
import CreditScoreWidget from './CreditScoreWidget';
import DigitalRetailingWidget from './DigitalRetailingWidget';
import MultiWidget from './MultiWidget';
import CheckAvailabilityWidget from './CheckAvailabilityWidget';

const WidgetShowcase = () => {
  const { widgetName } = useParams();

  return (
    <div>
      {widgetName === 'tradein' && <TradeInWidget />}
      {widgetName === 'leadgen' && <LeadGenWidget />}
      {widgetName === 'google_review' && <GoogleReviewWidget />}
      {widgetName === 'xrm_lead_gen' && <XRMLeadGenWidget />}
      {widgetName === 'credit-score' && <CreditScoreWidget />}
      {widgetName === 'digital-retailing' && <DigitalRetailingWidget />}
      {widgetName === 'multi-widget' && <MultiWidget />}
      {widgetName === 'check-availability' && <CheckAvailabilityWidget />}

      {[
        'tradein',
        'leadgen',
        'google_review',
        'xrm_lead_gen',
        'credit-score',
        'digital-retailing',
        'multi-widget',
        'check-availability',
      ].indexOf(widgetName) === -1 && <PageNotFound />}
    </div>
  );
};

export default WidgetShowcase;
